module.exports = __webpack_public_path__ + "img/20200418112931409.f5d7ace4.png";